import React from 'react';

export default function LeftPanelViewSwitch({ value, onChange }) {
  return (
    <div className="d-flex align-items-center" style={{ gap: 8 }}>
      
      <select
        className="form-select"
        style={{ width: 220 }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="positions">По позициям</option>
        <option value="supplies">По поставкам</option>
      </select>
    </div>
  );
}
